var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../services/user.service";
import { EduComponent } from "../../../utils/eduComponent";
import { LeaveRosterModalComponent } from "../../modals/leave-roster-modal/leave-roster-modal.component";
var StudentClassesComponent = /** @class */ (function (_super) {
    __extends(StudentClassesComponent, _super);
    function StudentClassesComponent(userService, modalService) {
        var _this = _super.call(this) || this;
        _this.userService = userService;
        _this.modalService = modalService;
        _this.classes = [];
        _this.rosterCode = "";
        _this.joinCodeEntered = new EventEmitter();
        _this.addSub(_this.userService.studentClasses.subscribe(function (classes) {
            _this.classes = classes.slice();
        }));
        _this.userService.loadStudentRosters();
        return _this;
    }
    StudentClassesComponent.prototype.submitJoinClass = function ($event, rosterCodeInput) {
        $event.preventDefault();
        if (rosterCodeInput.invalid) {
            return;
        }
        this.joinCodeEntered.emit(rosterCodeInput.value);
    };
    StudentClassesComponent.prototype.leaveClass = function ($event, roster) {
        $event.preventDefault();
        var modal = this.modalService.open(LeaveRosterModalComponent);
        modal.componentInstance.roster = roster;
        modal.componentInstance.classDetails =
            roster.teacher_name + "'s - " + roster.name;
    };
    return StudentClassesComponent;
}(EduComponent));
export { StudentClassesComponent };
